'use client';

import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { fadeInUp } from '@/lib/animations';

interface CardProps {
    children: ReactNode;
    className?: string;
    animate?: boolean;
}

export function Card({ children, className = '', animate = true }: CardProps) {
    if (!animate) {
        return (
            <div
                className={`
          w-full max-w-8xl mx-auto
          bg-white
          border-b border-slate-200
          p-6
          ${className}
        `}
            >
                {children}
            </div>
        );
    }

    return (
        <motion.div
            className={`
        w-full max-w-8xl mx-auto
        bg-white
        border-b border-slate-200
        p-6
        ${className}
      `}
            variants={fadeInUp}
            initial="hidden"
            animate="visible"
        >
            {children}
        </motion.div>
    );
}

interface CardHeaderProps {
    title: string;
    subtitle?: string;
}

export function CardHeader({ title, subtitle }: CardHeaderProps) {
    return (
        <div className="mb-8">
            <h1 className="text-3xl font-medium text-black">
                {title}
            </h1>
            {subtitle && (
                <p className="mt-2 text-slate-500">{subtitle}</p>
            )}
        </div>
    );
}
